// Separate Better Auth client from `auth-client.ts`: keeps the passkey plugin out of the default
// dashboard bundle. Session is shared via cookies, not in-memory state — any future plugin that
// requires shared in-memory state across the two clients needs explicit coordination.
import { passkeyClient } from "@better-auth/passkey/client";
import { createAuthClient } from "better-auth/react";
import { resolveAuthBaseUrl } from "./auth-client";

const createPasskeyClient = (baseURL: string) =>
  createAuthClient({
    baseURL,
    plugins: [passkeyClient()],
  });

type PasskeyAuthClient = ReturnType<typeof createPasskeyClient>;

let passkeyAuthClientInstance: PasskeyAuthClient | null = null;

function getPasskeyAuthClient() {
  if (!passkeyAuthClientInstance) {
    passkeyAuthClientInstance = createPasskeyClient(resolveAuthBaseUrl());
  }

  return passkeyAuthClientInstance;
}

export const passkeyAuth = {
  get signInWithPasskey() {
    return getPasskeyAuthClient().signIn.passkey;
  },
  get passkey() {
    return getPasskeyAuthClient().passkey;
  },
};
